function finiteNonNegativeNumber(value) {
    const number = Number(value);

    return Number.isFinite(number) ? Math.max(0, number) : 0;
}

function canonicalRatingCount(book = {}) {
    if (book.ratings_count === undefined || book.ratings_count === null) {
        return null;
    }

    return Math.trunc(finiteNonNegativeNumber(book.ratings_count));
}

function ratingCountForDisplay(book = {}) {
    return canonicalRatingCount(book)
        ?? Math.trunc(finiteNonNegativeNumber(book.reviews_count));
}

function hasPresentableRating(book = {}) {
    const rating = finiteNonNegativeNumber(book.rating);
    const count = canonicalRatingCount(book);

    return rating > 0 && (count === null || count > 0);
}

function formatTenPointRating(book = {}) {
    return hasPresentableRating(book)
        ? finiteNonNegativeNumber(book.rating).toFixed(1)
        : null;
}

function toFiveStarRating(rating) {
    return Math.min(5, finiteNonNegativeNumber(rating) / 2);
}

module.exports = {
    canonicalRatingCount,
    formatTenPointRating,
    hasPresentableRating,
    ratingCountForDisplay,
    toFiveStarRating
};
